export const applicanttrackingjobslistdata = [
  {
    Title: "Software Engineer",
    Company: "Tech Solutions",
    Openings: 5,
    Locations: "New York, USA",
    Start: "2025-04-01",
    End: "2025-06-01",
    Status: "Open",
  },
  {
    Title: "Data Scientist",
    Company: "Green Industries",
    Openings: 3,
    Locations: "San Francisco, USA",
    Start: "2025-04-15",
    End: "2025-06-15",
    Status: "Open",
  },
  {
    Title: "Product Manager",
    Company: "Web Works",
    Openings: 2,
    Locations: "London, UK",
    Start: "2025-03-20",
    End: "2025-05-20",
    Status: "Closed",
  },
  {
    Title: "UI/UX Designer",
    Company: "TechX Solutions",
    Openings: 4,
    Locations: "Los Angeles, USA",
    Start: "2025-04-10",
    End: "2025-06-10",
    Status: "Open",
  },
  {
    Title: "Marketing Specialist",
    Company: "Bright Future",
    Openings: 2,
    Locations: "Toronto, Canada",
    Start: "2025-05-01",
    End: "2025-07-01",
    Status: "Open",
  },
  {
    Title: "Sales Representative",
    Company: "Global Ventures",
    Openings: 6,
    Locations: "Sydney, Australia",
    Start: "2025-04-05",
    End: "2025-06-05",
    Status: "Open",
  },
  {
    Title: "HR Manager",
    Company: "Digital Corp",
    Openings: 1,
    Locations: "Chicago, USA",
    Start: "2025-03-15",
    End: "2025-05-15",
    Status: "Closed",
  },
  {
    Title: "Business Analyst",
    Company: "InnovateTech",
    Openings: 2,
    Locations: "Madrid, Spain",
    Start: "2025-04-20",
    End: "2025-06-20",
    Status: "Open",
  },
  {
    Title: "Full Stack Developer",
    Company: "NextGen Tech",
    Openings: 3,
    Locations: "Berlin, Germany",
    Start: "2025-05-01",
    End: "2025-07-01",
    Status: "Open",
  },
  {
    Title: "Operations Manager",
    Company: "TechX Solutions",
    Openings: 1,
    Locations: "Austin, USA",
    Start: "2025-03-25",
    End: "2025-05-25",
    Status: "Closed",
  },
  {
    Title: "DevOps Engineer",
    Company: "CloudNet",
    Openings: 4,
    Locations: "San Francisco, USA",
    Start: "2025-04-05",
    End: "2025-06-05",
    Status: "Open",
  },
  {
    Title: "Content Writer",
    Company: "SolarTech",
    Openings: 3,
    Locations: "London, UK",
    Start: "2025-04-01",
    End: "2025-06-01",
    Status: "Open",
  },
  {
    Title: "Project Manager",
    Company: "Web Works",
    Openings: 2,
    Locations: "New York, USA",
    Start: "2025-04-10",
    End: "2025-06-10",
    Status: "Open",
  },
  {
    Title: "Customer Support Specialist",
    Company: "FutureTech Innovations",
    Openings: 5,
    Locations: "Toronto, Canada",
    Start: "2025-03-10",
    End: "2025-05-10",
    Status: "Closed",
  },
  {
    Title: "Graphic Designer",
    Company: "NextWave Tech",
    Openings: 2,
    Locations: "Paris, France",
    Start: "2025-05-01",
    End: "2025-07-01",
    Status: "Open",
  },
  {
    Title: "Network Engineer",
    Company: "Tech Solutions",
    Openings: 3,
    Locations: "Singapore",
    Start: "2025-03-15",
    End: "2025-05-15",
    Status: "Open",
  },
  {
    Title: "SEO Specialist",
    Company: "Innovative Designs",
    Openings: 1,
    Locations: "Los Angeles, USA",
    Start: "2025-04-01",
    End: "2025-06-01",
    Status: "Closed",
  },
  {
    Title: "Database Administrator",
    Company: "Blue Ocean Ventures",
    Openings: 2,
    Locations: "Miami, USA",
    Start: "2025-04-10",
    End: "2025-06-10",
    Status: "Open",
  },
  {
    Title: "Software Architect",
    Company: "TechX Solutions",
    Openings: 1,
    Locations: "Berlin, Germany",
    Start: "2025-05-01",
    End: "2025-07-01",
    Status: "Open",
  },
  {
    Title: "Business Development Manager",
    Company: "Prime Innovations",
    Openings: 4,
    Locations: "London, UK",
    Start: "2025-04-15",
    End: "2025-06-15",
    Status: "Open",
  },
];
